/* eslint-disable @next/next/no-img-element */
"use client";
import React, { useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { useRouter } from "next/navigation";
import styles from "@/src/styles/modals.module.css";
import { translatedVariants } from "@/src/Utils/translationObject";
import axios from "axios";
import { AppNotify } from "@/src/Utils/AppNotify";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  width: "calc(100% - 20px)",
  maxWidth: "560px",
  height: "auto",
  borderRadius: "16px",
  outline: "none",
  padding: { xs: "20px 22px 26px 22px", sm: "30px 32px 36px 32px" },
};

const VerifyCertificateModal = ({
  open,
  handleClose,
  id,
}: {
  open: boolean;
  handleClose: () => void;
  id: string;
}) => {
  // Router
  const router = useRouter();

  // States
  const [certificateNumber, setCertificateNumber] = useState("");

  const handleCreateCertificate = async (e) => {
    e.preventDefault();
    const resp = await axios.post(
      process.env.NEXT_PUBLIC_GET_CERTIFICATE as string,
      {
        certificate_number: certificateNumber,
      }
    );

    if (resp.data.status && !resp.data.expired) {
      router.push(`/certificate/${resp.data.data.docId}`);
    } else {
      AppNotify("Please enter a valid Certificate Number.", "error");
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          ...style,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className={styles.modalHead}>
          <h2 className={styles.modalTitle}>
            {id === ""
              ? "Verify Certificate"
              : translatedVariants[id as keyof typeof translatedVariants]
                  .certificate_heading}
          </h2>
          <p className={styles.modalText}>
            {id === ""
              ? "Enter a certificate number to continue"
              : translatedVariants[id as keyof typeof translatedVariants]
                  .enter_certificate_number}
          </p>
        </div>
        <div className={styles.modalFooter}>
          <form className={styles.modalForm} onSubmit={handleCreateCertificate}>
            <input
              required={true}
              className={styles.modalInput}
              type={"text"}
              onChange={(e) => setCertificateNumber(e.target.value)}
              placeholder={
                id === ""
                  ? "Enter certificate number here"
                  : translatedVariants[id as keyof typeof translatedVariants]
                      .enter_certificate_number
              }
            />
            <Button
              className={styles.modalSubmit}
              variant="contained"
              type={"submit"}
            >
              {id === ""
                ? "Verify"
                : translatedVariants[id as keyof typeof translatedVariants]
                    .verifify_certificate}
            </Button>
          </form>
        </div>
      </Box>
    </Modal>
  );
};

export default VerifyCertificateModal;
